/* ── Bad Bunzy Contact — bb-contact.js ── */

(function () {
  'use strict';

  // ── FAQ ACCORDION ──
  function initFaq() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.bbct-faq-trigger');
      if (!trigger) return;

      var panel  = trigger.nextElementSibling;
      var isOpen = trigger.classList.contains('active');

      document.querySelectorAll('.bbct-faq-panel').forEach(function (p) { p.classList.remove('open'); });
      document.querySelectorAll('.bbct-faq-trigger').forEach(function (t) { t.classList.remove('active'); });

      if (!isOpen && panel) {
        panel.classList.add('open');
        trigger.classList.add('active');
      }
    });
  }

  // ── CHARACTER COUNTER ──
  function initCharCounter() {
    var textarea = document.getElementById('bbct-message');
    var counter  = document.getElementById('bbct-char-count');
    if (!textarea || !counter) return;
    textarea.addEventListener('input', function () {
      counter.textContent = textarea.value.length;
    });
  }

  // ── FILE ATTACHMENT LABEL ──
  function initFileAttach() {
    var fileInput  = document.getElementById('bbct-file');
    var attachHint = document.getElementById('bbct-attach-hint');
    if (!fileInput || !attachHint) return;

    attachHint.addEventListener('click', function () { fileInput.click(); });

    fileInput.addEventListener('change', function () {
      var label = attachHint.querySelector('span:last-of-type');
      if (label && fileInput.files.length > 0) {
        label.textContent = fileInput.files[0].name;
      }
    });
  }

  // ── SCROLL REVEAL ──
  function initReveal() {
    if (!window.IntersectionObserver) {
      document.querySelectorAll('.bbct-reveal').forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.bbct-reveal').forEach(function (el) { obs.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFaq();
      initCharCounter();
      initFileAttach();
      initReveal();
    });
  } else {
    initFaq();
    initCharCounter();
    initFileAttach();
    initReveal();
  }
})();
